import TransducerGoogleChirp1 from "./TransducerGoogleChirp1";

export default TransducerGoogleChirp1;
